import styled from 'styled-components';
import PropTypes from "prop-types";
import { device } from "../device";

const H4 = styled.h4`
    font-size: 24px;
    font-weight: 400;
    line-height: 1.2;
    margin: 0;

    padding: ${({space}) => 
        (space === 'Top' && '80px 0 0') ||
        (space === 'TopDown' && '80px 0 32px') || 
        (space === 'Down' && '0 0 32px') || 
        '0'
    };

    @media ${device.lg} {
        font-size: 32px;
    }
`;

H4.propTypes = {
    space: PropTypes.string
};

export default H4;